import clock from '../../assets/icons/clock.png'
import loc from '../../assets/icons/location-pin.png'
import heart from '../../assets/icons/cardiogram.png'
import doctorImg from '../../assets/images/doctors/doctor.png'
import star from '../../assets/icons/white-star.png'

const DoctorProfileBox = ({ doctor }) => {
  console.log(doctor);
  
  return (
    <div className='flex flex-row items-center md:flex-row gap-5'>

      {/* تصویر و امتیاز */}
      <div className='flex items-center gap-2'>
        <div className='relative w-fit'>
          <img
            src={doctor.thumb ? `https://bit.medizen.ir/i/${doctor.thumb}` : doctorImg}
            alt={doctor.name}
            className='w-[120px] h-[120px] min-w-[120px]
            md:max-w-[200px] md:max-h-[200px]
            lg:h-[300px] lg:w-[300px]
            object-cover rounded-[50%]'
          />
          <span
            className='flex items-center w-fit px-3 justify-center
            rounded-[50px] text-white bg-[#FFBB00] absolute -bottom-2
            left-1/2 -translate-x-1/2'>
            <span>{doctor.score}</span>
            <img src={star} className='w-5 object-contain' />
          </span>

          {/* وضعیت فعال بودن */}
          <span
            className={`absolute w-4 h-4
              border border-white rounded-full
              top-[15%] right-[2%]
              md:right-[6%]
              ${
              doctor.activity_status === "active" ? "bg-[#0DCB2D]" : "bg-gray-400"
            }`}
          ></span>
        </div>
      </div>

      {/* اطلاعات پزشک */}
      <div className='w-full flex gap-4 flex-col'>
        <div className='flex flex-col gap-2'>
          <h4 className='font-semibold text-lg'>{doctor.name}</h4>
          <p className='text-gray-600 font-medium'>{doctor.title}</p>
        </div>

        <div className="flex flex-col md:flex-row md:justify-start gap-2 xl:gap-10 text-sm">
          <div className="flex gap-1 items-center">
            <img src={heart} className='w-4 object-contain' />
            <span>نظام پزشکی:</span>
            <span>{doctor.medical_system_no}</span>
          </div>

          <div className="flex gap-1 items-center">
            <img src={clock} className='w-4 object-contain' />
            <span>تجربه:</span>
            <span>{doctor.experience_years} سال</span>
          </div>

          <div className="flex gap-1 items-center">
            <img src={loc} className='w-4 object-contain' />
            <span>شهر:</span>
            <span>{doctor.city_name=='NaN'?'ذکر نشده':doctor.city_name}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DoctorProfileBox
